import React, { createContext, useContext, useState, useEffect } from 'react';

// Favorite masjids (ids), kept in this browser only.
const MosqueContext = createContext();
const STORAGE_KEY = 'favoriteMosques';

export const MosqueProvider = ({ children }) => {
    const [favorites, setFavorites] = useState([]);

    useEffect(() => {
        try {
            const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
            if (Array.isArray(saved)) setFavorites(saved.map(String));
        } catch { /* storage blocked or corrupt: start empty */ }
    }, []);

    const toggleFavorite = (mosqueId) => {
        setFavorites((prev) => {
            const id = String(mosqueId);
            const next = prev.includes(id) ? prev.filter((f) => f !== id) : [...prev, id];
            try { localStorage.setItem(STORAGE_KEY, JSON.stringify(next)); } catch { /* ignore */ }
            return next;
        });
    };

    return (
        <MosqueContext.Provider value={{ favorites, toggleFavorite }}>
            {children}
        </MosqueContext.Provider>
    );
};

export const useMosqueContext = () => useContext(MosqueContext);
